export const stageData = [
   {
      code: 'ixtul',
      currency: 'MXN',
      language: 'es-mx',
      account: {
         code: 'ixtul',
         name: 'Ixtul',
         telephones: ['+52 (998) 282 2365'],
         logoObj: {
            base: 'https://res.cloudinary.com/itermotus/',
            path: 'assets/logo-soulbeach2.jpg',
            width: 175,
            height: 60,
         },
         siteUrl: 'https://ixtul.revenatium-stage.com',
         webSiteUrl: '/',
         containerId: 'GTM-KHLBTH8',
         faviconUrl: 'https://assets.revenatium.com/hotelsoulbeach/favicon.ico',
         languages: [
            {
               flag: 'es',
               language: 'es-mx',
               name: 'Espanol',
               siteUrl: '',
            },
            {
               flag: 'en',
               language: 'en-us',
               name: 'English',
               siteUrl: '',
            },
         ],
         currencies: [
            {
               flag: 'mx',
               code: 'MXN',
               name: 'Mexican Peso',
               symbol: '$',
            },
            {
               flag: 'us',
               code: 'USD',
               name: 'United States Dollar',
               symbol: '$',
            },
         ],
      },
      hotelForm: {
         startDate: null,
         endDate: null,
         rooms: [{ adults: 2, children: 0, childrenAges: [] }],
         maxAdults: 8,
         maxRooms: 3,
         maxChildren: 4,
         minChildrenAge: 0,
         maxChildrenAge: 17,
         quoteRates: true,
         hasMultiDestination: true,
      },
      hotelFlightForm: {
         origin: {
            id: null,
            displayText: null,
            code: null,
         },
         destination: null,
         startDate: null,
         endDate: null,
         rooms: [
            {
               adults: 2,
               children: 0,
               childrenAges: [],
            },
         ],
         maxRooms: 3,
         maxAdults: 6,
         maxChildren: 2,
         minChildrenAge: 0,
         maxChildrenAge: 7,
         postUrl: '',
         promotionCode: null,
         hasPromotionCodeEnabled: true,
         hasMultiDestination: true,
      },
      theme: {
         headerBgColor: '#000000',
         primaryColor: '#8d713a',
         // "bookerPaddingHorizontal": "1rem",
         // "bookerPaddingVertical": "1rem",
         // "bookerRadius": "9999px",
         // "bookerBgColor": "#ffffff",
         // "bookerBgOpacity": 0.85,
         // "bookerBorderColor": "#f2f2f2",
         // "bookerBorderWidth": 0.0,
         // "bookerA11yColor": "#000000",
         // "bookerOverlaysRadius": "1rem",
         hotels: {
            'hotel-laguna': {
               primaryColor: '#ffffff',
               primaryBorderColor: '#c30359',
               accessiblePrimaryColor: '#c30359',
               primaryColorOutline: '#c30359',
               primaryColorOutlineHover: '#c30359',
               accessiblePrimaryColorOutlineHover: '#ffffff',
               primaryBookerBgColor: '#c30359',
               accessiblePrimaryBookerBgColor: '#ffffff',
               // primaryBookerBorderColor: '#ffffff',
               calendarColor: '#c30359',
               successAmenityColor: '#333333',
               infoIconColor: '#5db85b',
               warningColor: '#c30359',
               linkColor: '#c30359',
            },
         },
      },
      dateFormat: 'MMM D',
      apiUserName: 'hotelsoulbeach-stage-es@revenatium.com',
      apiPassword: 'aue9umn5uak@HZB@bwb',
      hasAddOns: true,
      showAlerts: true,
      loyaltyEnabled: true,
      flightProvider: 'PriceTravelFQS',
      showSliderGallery: false,
      flags: {
         useAlgolia: true,
         enableRoomHolders: true,
         disableRoomComparator: false,
         hideFooterBenefits: false,
         showProfile: true,
         showOfficialSiteOnHeader: false
         // allowBookerStylesOnBE: true
      },
      // bookerVersion: "padded",
      // roomListVersion: "grid",
      buttonStyle: 'outline',
      bookerPlaces: [
         {
            "id": 1,
            "name": "Hotel Flamingos",
            "uri": "hotel-flamingos",
            "place": {
               "id": 1,
               "name": "Cancun",
               "airportCode": "CUN"
            },
            "chain": null,
            "url": null
         },
         {
            "id": 5,
            "name": "Hotel Laguna",
            "uri": "hotel-laguna",
            "place": {
               "id": 1,
               "name": "Cancun",
               "airportCode": "CUN"
            },
            "chain": null,
            "url": null
         }
      ],
      customFooterHtmlLocalized: {
         es: `
         <footer class="relative pt-4 flex justify-center min-h-[150px]">
         <div class="absolute inset-0 h-full -z-[1]"> <div class="absolute inset-0 flex justify-between w-full"> <!-- Hoja izquierda --> <img src="https://res.cloudinary.com/itermotus/w_600/assets/hotelesmision/generales/hojasizquierda.svg" alt="" class="leaf-left h-70 w-80 xl:w-170 object-left object-contain opacity-20 will-change-transform"> <!-- Hoja derecha --> <img src="https://res.cloudinary.com/itermotus/w_600/assets/hotelesmision/generales/hojasderecha.svg" alt="" class="hidden md:block leaf-right h-70 w-80 xl:w-170 object-right object-contain opacity-20 will-change-transform"> </div> </div>
         <div class="itm-container flex justify-center">
         <ul class="space-y-2"><li><a href="/quienes-somos" class="hover:underline">Nosotros</a></li><li><a href="/marcas" class="hover:underline">Nuestras marcas</a></li><li><a href="/contacto" class="hover:underline">Contacto</a></li></ul>
         </div>
         </footer>`},
      chatbotConfig: {
         accountCode: "ixtul",
         enabled: true,
         show: false,
         title: "",
         skills: [
            "PROMOTIONS",
            "FIND_ITINERARY",
            "RESERVE",
            "LOCATION"
         ],
         name: "Asuka",
         color: "#2196F3",
         position: "RIGHT",
         notification: {
            enabled: true,
            trigger: "DELAY",
            delaySeconds: 3
         },
         i18n: {
            en: {
               welcomeMessage: "Welcome! How can I help you today?",
               inputPlaceholder: null
            },
            es: {
               welcomeMessage: "¡Bienvenido! ¿En qué puedo ayudarte hoy?",
               inputPlaceholder: null
            }
         },
         personality: "FRIENDLY",
         offset: {
            x: 0,
            y: 11
         },
         mode: "SKILLS",
         avatar: {
            base: "https://res.cloudinary.com/itermotus",
            path: "/assets/chat/M0.jpg"
         }
      },
   }
]